import React, { useState, useEffect } from "react";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { Box, Button, Grid, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CmtCardFooter from "@coremat/CmtCard/CmtCardFooter";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { Add } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import CmtCard from "@coremat/CmtCard";
import GridContainer from "@jumbo/components/GridContainer";

import CustomDialog from "../AccessList/CustomDialog";
import CustomDatePicker from "./components/datePicker";
import { dateFormat } from "@jumbo/utils/shamsiStandardFormat";
import FilePickerContainer from "./components/filePicker";
import { convertToStandardFormat } from "@jumbo/utils/shamsiStandardFormat";
import MediaRequests from "services/media";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import { DateObject } from "react-multi-date-picker";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    marginTop: 10,
  },
  titleInput: {
    width: "100%",
  },
  formControl: {
    width: "100%",
  },
  title: {
    color: theme.palette.primary.main,
    marginBottom: "16px",
    fontWeight: "bold",
  },
  previewContainer: {
    width: "100%",
    display: "flex",
    marginTop: "16px",
    justifyContent: "center",
    "& img": {
      width: "190px",
      marginInline: "auto",
      borderRadius: "1rem",
    },
  },
  removeButton: {
    cursor: "pointer",
  },
}));

const GalleryElement = ({ gallery }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [galleryTitle, setgalleryTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [galleryMedia, setGalleryMedia] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [openEditDialog, setopenEditDialog] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [eventDate, setEventDate] = useState(dateFormat);

  const resetState = () => {
    setgalleryTitle("");
    setDesc("");
    setGalleryMedia([]);
  };

  useEffect(() => {
    if (gallery) {
      setgalleryTitle(gallery.name);
      setDesc(gallery.description);
      setGalleryMedia(gallery.files);
      setEventDate({
        date: gallery.eventDate,
        gregorian: new DateObject({
          date: gallery.eventDate,
          format: "HH:mm:ss   YYYY/MM/DD",
        })
          .convert(gregorian, gregorian_en)
          .format(),
      });
    }
  }, [gallery]);

  const handleAddAndClose = () => {
    let media = galleryMedia.map((item) => {
      return item._id;
    });
    const data = {
      name: galleryTitle,
      description: desc,
      eventDate: convertToStandardFormat(eventDate.gregorian),
      files: media,
    };
    dispatch(MediaRequests.createGallery(data));
    resetState();
    setOpenAddDialog(false);
  };

  const handleEditAndClose = () => {
    let media = galleryMedia.map((item) => {
      return item._id;
    });
    const data = {
      name: galleryTitle,
      description: desc,
      eventDate: convertToStandardFormat(eventDate.gregorian),
      files: media,
    };
    dispatch(MediaRequests.updateGallery(gallery._id, data));
    setopenEditDialog(false);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleRemoveAndClose = () => {
    dispatch(MediaRequests.DeleteGallery(gallery._id));
    setOpenDialog(false);
  };

  return (
    <React.Fragment>
      <div className={classes.cardContainer}>
        <CmtCard>
          <CmtCardContent>
            <GridContainer>
              <Grid item xs={12} md={6}>
                <Typography className={classes.title}>نام گالری</Typography>
                <TextField
                  id="galleryTitle"
                  label="نام گالری"
                  variant="outlined"
                  className={classes.titleInput}
                  value={galleryTitle}
                  onChange={(e) => setgalleryTitle(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography className={classes.title}>توضیحات</Typography>
                <TextField
                  id="description"
                  label="توضیحات"
                  variant="outlined"
                  className={classes.formControl}
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomDatePicker
                  title={"انتخاب تاریخ"}
                  value={eventDate}
                  setValue={setEventDate}
                />
              </Grid>
            </GridContainer>
            <FilePickerContainer
              media={galleryMedia}
              setMedia={setGalleryMedia}
            />
          </CmtCardContent>

          <CmtCardFooter
            separator={{
              color: "#bdbdbd",
              borderWidth: 1,
              borderStyle: "solid",
            }}
          >
            <Box>
              {gallery ? (
                <>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<DeleteIcon />}
                    onClick={() => setOpenDialog(true)}
                    style={{ marginRight: 14 }}
                  >
                    حذف
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<EditIcon />}
                    onClick={() => setopenEditDialog(true)}
                    style={{ marginRight: 14 }}
                  >
                    ویرایش
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<Add />}
                    onClick={() => setOpenAddDialog(true)}
                    style={{ marginRight: 14 }}
                  >
                    ایجاد گالری
                  </Button>
                </>
              )}
            </Box>
          </CmtCardFooter>
        </CmtCard>
      </div>
      <CustomDialog
        open={openDialog}
        action={handleRemoveAndClose}
        handleClose={handleClose}
        text={"آیا از حدف این گالری اطمینان دارید ؟"}
      />
      <CustomDialog
        open={openEditDialog}
        action={handleEditAndClose}
        handleClose={() => setopenEditDialog(false)}
        text={" آیا از ویرایش این گالری اطمینان دارید ؟"}
      />
      <CustomDialog
        open={openAddDialog}
        action={handleAddAndClose}
        handleClose={() => setOpenAddDialog(false)}
        text={"آیا از اضافه کردن این گالری اطمینان دارید ؟"}
      />
    </React.Fragment>
  );
};

export default GalleryElement;
